import React from 'react'
import './Work.scss'
export default function Work() {
  return (
    <>
       <div className='container-fluid' id="work-c-f">
            <div className='container' id="work-c">
                {/* <h3 className='text-center'>Our Work</h3> */}
                <h3 className='text-center'>My Projects</h3>
                <div className='row'>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://images.pexels.com/photos/2781814/pexels-photo-2781814.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt=""></img>
                            <p><b>Bharat Jyoti School Anuppur</b></p>
                            <button className='btn btn-info'><a href="https://bjvanuppur.in/" target='blank' className='text-white'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/6e/11/50/6e1150f0c0a9edacdbaf851e5c47b696.jpg" alt=""></img>
                            <p><b>Weather App</b></p>
                            <button className="btn btn-info"><a href="https://github.com/16Yogi/Weather" target='blank' className='text-white'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/13/a4/b7/13a4b7dd33f3df1e1b3affc1ef4d3bc5.png" alt=""></img>
                            <p><b>Amarkantak Darshan</b></p>
                            <button className="btn btn-info"><a href="https://github.com/16Yogi/AmarkantakDarshan"className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/a8/fe/ce/a8feced6baf59528e659f9ab4befc50a.jpg" alt=""></img>
                            <p><b>World Tour & Travel</b></p>
                            <button className="btn btn-info"><a href="https://github.com/16Yogi/WorldTourAndTravel"className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://images.pexels.com/photos/8294606/pexels-photo-8294606.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt=""></img>
                            <p><b>Voice Assistant</b></p>
                            <button className="btn btn-info"><a href="https://github.com/16Yogi/JarvisMyVoiceAssistance"className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/7d/89/0a/7d890aaa5aa84a684ffccfcbfbce817a.png" alt=""></img>
                            <p><b>Beangate Academy</b></p>
                            <button className="btn btn-info"><a href="https://academy.beangates.com/"className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/95/10/75/951075e7f474152435f7809dc9aa1f1a.jpg" alt=""></img>
                            <p><b>RS Online</b></p>
                            <button className="btn btn-info"><a href="https://github.com/16Yogi/RSonline"className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/1e/e1/a6/1ee1a6bb8341959b3bfd411a975cd532.png" alt=""></img>
                            <p><b>Intership Project</b></p>
                            <button className="btn btn-info"><a href="https://github.com/16Yogi/Project-tour-2" className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/69/6a/7d/696a7d780117bd4752def26c04bd8428.png" alt=""></img>
                            <p><b>My Shoes</b></p>
                            <button className="btn btn-info"><a href="https://myshoues.netlify.app" className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/97/6f/42/976f429fa3608621288c8f0bf418ebe5.jpg" alt=""></img>
                            <p><b>Apni Zameen</b></p>
                            <button className="btn btn-info"><a href="https://github.com/16Yogi/Hashim" className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://i.pinimg.com/originals/9b/99/c8/9b99c895f2ffeab8fbe5d355c6f8ad62.jpg" alt=""></img>
                            <p><b>My Portfolio</b></p>
                            <button className="btn btn-info"><a href="https://yogendrameravi.netlify.app/" className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-6 col-sm-12' id="work-item-wrap">
                        <div className='col p-0' id="work-item">
                            <img src="https://images.pexels.com/photos/1495580/pexels-photo-1495580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt=""></img>
                            <p><b>Electrician</b></p>
                            <button className="btn btn-info"><a href="https://github.com/16Yogi/Gautam" className='text-white' target='blank'>Click Here</a></button>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </>
    )
}
